// home-editor-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Esta rede não possui integração com o Firebase configurada. A ordem das seções e os blocos de imagem da Tela Inicial ficam indisponíveis até que o arquivo de service account seja cadastrado no cadastro da rede.": "Esta red no tiene integración con Firebase configurada. El orden de las secciones y los bloques de imagen de la Pantalla de Inicio quedan no disponibles hasta que el archivo de service account sea registrado en el registro de la red.",
    "Prévia da Home": "Vista previa del Inicio",
    "Tela Inicial do App": "Pantalla de Inicio de la App",
};

export default catalogo;
